<template>
  <div id="app">
    <b-container class="mt-5">
      <b-col cols="12">
        <div>
          <b-row v-if="type == 'single'">
            <b-col cols="12">
              <div id="navigation-title" v-if="communityData">

                <b-row>
                </b-row>
                <b-row v-if="!hideheader">

                  <b-col cols="12" v-if="communityData.baseData" class="text-center">
                    <b-img :src="communityData.baseData.logoHochladen[0].url" fluid></b-img>
                  </b-col>
                  <b-col v-if="1 > 2">

                    <h1 style="line-height: 1" class="text-center">
                      <span v-if="communityData.baseData">
                        {{ communityData.baseData.stamm_gemeindename }}
                      </span>
                    </h1>
                    <h2>
                      <small style="display: block" v-if="communityData.baseData">


                        <i> {{ communityData.baseData.stamm_slogan }}</i></small>
                    </h2>


                  </b-col>
                  <b-col cols="12">
                    <br>
                    <b-row>

                      <b-col cols="10">

                        <h3 v-if="!$route.path.includes('thankyou')"> {{ currentForm.formName }}</h3>

                      </b-col>
                      <b-col v-if="options.length > 1">


                        <b-form-select v-model="language" :options="options"></b-form-select>


                      </b-col></b-row>
                  </b-col>
                </b-row>
              </div>
            </b-col>

          </b-row>
          <b-row>
            <b-col>


              <div id="messages" role="alert" style="display: none;"></div>
              <div id="renderer" v-if="type == 'single'"></div>


              <DynamicComponent v-else :templateId="form" :key="updateKey">
              </DynamicComponent>

              <div class="loading-background" v-if="show" rounded="sm">
                <span class="loader">
                </span>
                <br>
                <h3>Daten werden gesendet....</h3>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-container>
  </div>
</template>
<script>
import config from "./config/config.js";
import axios, { AxiosError } from "axios";
import moment from "moment";
import { Formio } from "formiojs";
import "./components/formio/SummaryComponent.js";


export default {
  props: ["type", "community", "form", "pid", "hideheader"],
  data() {
    return {
      currentForm: {},
      formioForm: null,
      communityData: {},
      _sessionId: null,
      translations: [],
      language: "de",
      payed: false,
      updateKey: "",
      show: false,
      token: null,
      options: [
        { value: "de", text: 'Deutsch', selected: true }/*,
        { value: "en", text: 'English' },
         { value: "fr", text: "Français" },
         { value: "sa", text: "اَللُّغَةُ اَلْعَرَبِيَّة" },
         { value: "pl", text: "Polski" },
         { value: "uk", text: "українська " }*/
      ],
      elements: null,
      paymentElement: null,
      hasPayment: false,
      costs: [
      ]
      , paymentData: {},
      payString: "",
    };
  },
  mounted() {
    let self = this;

    if (!this.$session.exists()) {
      this.$session.start();
    }
    let loginData = {
      userName: this.$session.id(),
      password: "",
      ApplicationKey: config.APP_KEY,
    };
    window.costs = self.costs;
    self._sessionId = loginData.userName
    window.sessionId = self._sessionId;

    window.paymentSuccessfull = false;
    const queryStringStripe = window.location.search;

    const urlParams = new URLSearchParams(queryStringStripe);
    const stripe_session_id = urlParams.get('session_id');
    if (stripe_session_id) {
      window.stripe_session_id = stripe_session_id;
    }
    axios
      .post(config.API_URL + "/api/authenticateBySession/", loginData, {
        headers: { "Content-Type": "application/json" },
      })
      .then((response) => {
        if (response.status == "201" || response.status == "200") {
          self.$session.set("token", response.data);
          self.token = response.data;
          axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${response.data}`;




          let formCommunityDTO = {
            formId: self.form,
            communityIdentifier: self.community,
          };

          window.formCommunityDTO = formCommunityDTO;

          axios
            .get(config.API_URL + "/api/dynamicquery/translations/")
            .then((responseLang) => {
              if (responseLang.status == 200) {



                let languages = responseLang.data[0].languages

                var objectWithGroupByName = {};
                for (var key in languages) {
                  var name = languages[key].isoCode;



                  if (!objectWithGroupByName[name]) {
                    objectWithGroupByName[name] = [];
                  }


                  var parse = languages[key].languageObject.split(":");


                  let object = {
                    [parse[0]]: parse[1]
                  }

                  objectWithGroupByName[name][parse[0]] = parse[1];
                }
                let temp = objectWithGroupByName;
                self.translations = temp;

                if (self.$route.path.includes("thankyou")) {
                  formCommunityDTO = {
                    formId: self.form,
                    communityIdentifier: self.community,
                  };
                }

                axios
                  .post(
                    config.API_URL + "/api/communityData/" + self.community,
                    formCommunityDTO,
                    {
                      headers: { "Content-Type": "application/json" },
                    }
                  )
                  .then((response) => {
                    self.communityData = response.data;



                    if (JSON.parse(
                      response.data.baseData.value
                    ) != null) {
                      self.communityData.baseData = JSON.parse(
                        response.data.baseData.value
                      ).data;
                    } else {

                      self.communityData.baseData = []
                    }
                    self.communityData.customizing = {};
                    if (response.data.customizingValues != undefined) {

                      if (response.data.customizingValues.value) {
                        self.communityData.customizing = JSON.parse(
                          response.data.customizingValues.value
                        ).data;
                      }
                    } else {
                      self.communityData.customizing = {};
                    }
                    window.communityData = self.communityData;


                    if (self.type == "single") {
                      axios
                        .get(config.API_URL + "/api/form/" + self.form + "/" + self.community)
                        .then((response) => {





                          self.currentForm = JSON.parse(response.data.form.value);

                          window.currentForm = self.currentForm;
                          window.currentForm.isProductive = response.data.cStatus;
                          window.currentForm.communityData = response.data.hasPayment;

                          document.title = self.currentForm.formName + " | " + self.communityData.communityName
                          let defItem = "";

                          if (
                            typeof JSON.parse(response.data.form.value).formDefintion ===
                            "string"
                          ) {
                            defItem = JSON.parse(
                              JSON.parse(response.data.form.value).formDefintion
                            );
                          } else {
                            defItem = JSON.parse(response.data.form.value).formDefintion;
                          }
                          let newDefinition = defItem;





                          if (self.currentForm.hasPayment) {

                            newDefinition.components.push(
                              {
                                "title": "Bezahlung",
                                "breadcrumbClickable": false,
                                "buttonSettings": {
                                  "previous": true,
                                  "cancel": true,
                                  "next": false,
                                  "submit": true
                                },
                                "navigateOnEnter": false,
                                "saveOnEnter": false,
                                "scrollToTop": false,
                                "collapsible": false,
                                "key": "payment",
                                "type": "panel",
                                "label": "Bezahlung",
                                "input": false,
                                "tableView": false,
                                "components": [
                                  {
                                    "label": "HTML",
                                    "attrs": [
                                      {
                                        "attr": "",
                                        "value": ""
                                      }
                                    ],
                                    "content": "<div id=\"checkout\">\n\n</div>",
                                    "refreshOnChange": false,
                                    "hidden": true,
                                    "key": "htmlDivI",
                                    "customConditional": "if(instance.root.page == instance.page)\n{\nshow = true;\nconsole.log(\"instance\",instance);\n}",
                                    "logic": [
                                      {
                                        "name": "test",
                                        "trigger": {
                                          "type": "javascript",
                                          "javascript": "result = 1<2"
                                        },
                                        "actions": [
                                          {
                                            "name": "test",
                                            "type": "customAction",
                                            //     "customAction": "if (instance.root.page == instance.page && !window.checkoutMounted && !window.stripe_session_id) {\r\n\r\n    const stripe = Stripe(\"pk_test_51PHMUVFTG7zD3nB4vs9Q9eCYWIHEr23Fxtcq3rnSS145Bj6dqEeU0cqb1BfW7crK1EgXWeEhQkp48v4rW7J1506500DEDEZz8s\");\r\n\r\n    initialize();\r\n\r\n    // Create a Checkout Session\r\n    async function initialize() {\r\n        window.checkoutMounted = false;\r\n        const handleComplete = async function () {\r\n            // Destroy Checkout instance\r\n            //checkout.destroy()\r\n            window.GlobalVueInstance.methods.submitForm();\r\n        }\r\n        const fetchClientSecret = async () => {\r\n            const response = await fetch(window.GLOBALCONFIG.API_URL + \"/api/create-session-checkout\", {\r\n                method: \"POST\",\r\n                body: JSON.stringify(" + self.payString + ")\r\n            });\r\n            console.log(response.body);\r\n            const { clientSecret } = await response.json();\r\n            return clientSecret;\r\n        };\r\n\r\n        window.checkout = await stripe.initEmbeddedCheckout({\r\n            fetchClientSecret, onComplete: handleComplete\r\n        });\r\n\r\n        // Mount Checkout\r\n        if (window.checkoutMounted && window.stripe_session_id) {\r\n            console.log(window.checkout);\r\n        }\r\n        else {\r\n            window.checkout.mount('#checkout');\r\n            window.checkoutMounted = true;\r\n            console.log(window)\r\n        }\r\n    }\r\n\r\n}",
                                            "content": "<div class=\"well\">Content</div>"
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "htmlelement",
                                    "input": false,
                                    "tableView": false
                                  }
                                ]

                              })


                          }


                          if (self.$route && self.$route.path && self.$route.path.includes("thankyou")) {
                            newDefinition.display = "form";
                          }



                          Object.keys(self.communityData.customizing).forEach(
                            function (key) {
                              newDefinition = self.replaceKeysInObj(
                                defItem,
                                "Data_" + key,
                                self.resolve(key, self.communityData.customizing)
                              );
                            }
                          );

                          window.formDefinition = newDefinition;
                          let translation = self.$root.$children[0].translations;


                          Formio.setBaseUrl(config.API_URL + "/api/formManager");
                          Formio.setProjectUrl(config.API_URL + "/api/formManager");

                          self.formioForm = Formio.createForm(
                            document.getElementById("renderer"),
                            newDefinition,
                            {
                              saveDraft: true,
                              skipDraftRestore: true,
                              hooks: {

                                beforeSubmit: (submission, next) => {

                                  next();
                                },
                                beforeNext: (currentPage, submission, next) => {

                                  window.draftSubmission = submission;
                                  localStorage.setItem('currentData_' + self.form + '_' + window.sessionId, JSON.stringify(submission.data));

                                  if (!self.currentForm.hasPayment) {
                                    if (
                                      document.getElementsByClassName("summaryContainer")
                                        .length > 0
                                    ) {
                                      window.summary =
                                        document.getElementById(
                                          "summaryContainer"
                                        )[0].innerHTML;
                                    }



                                  }
                                  else {


                                    if (submission.data && submission.data.nfProduktbestellungVorschau) {
                                      self.costs = submission.data.nfProduktbestellungVorschau.data.costs;
                                    }


                                  }
                                  setLanguage(self.language)
                                  next();
                                }
                              },

                              language: "de",

                              i18n: translation

                            }
                          )
                            .then(function (wizard) {



                             


                              var currentData = localStorage.getItem('currentData_' + self.form + '_' + window.sessionId);
                              if (currentData) {
                                wizard.submission = { data: JSON.parse(currentData) };
                              }







                              window.form = wizard;




                              self.language = "de"
                              window.setLanguage = function (lang) {
                                wizard.language = lang;
                              };
                              setLanguage("de");


                              setLanguage(self.language)
                              // Prevent the submission from going to the form.io server.
                              wizard.nosubmit = false;

                              wizard.on("nextPage", function (page, submission) {
                                window.formDefinition = wizard.schema;
                                window.draftSubmission = page.submission;
                                setLanguage(self.language);


                                if ((wizard.root.pages.length - 1) == page.page) {


                                  self.paymentData = {};
                                  self.paymentData.costs = page.submission.data.nfProduktbestellungVorschau.data.costs;
                                  self.paymentData.session = window.sessionId;
                                  self.payString = JSON.stringify(self.paymentData);

                                  const stripe = Stripe("pk_test_51PHMUVFTG7zD3nB4vs9Q9eCYWIHEr23Fxtcq3rnSS145Bj6dqEeU0cqb1BfW7crK1EgXWeEhQkp48v4rW7J1506500DEDEZz8s");


                                  initialize();





                                  async function initialize() {


                                    window.checkoutMounted = false;
                                    const handleComplete = async function () {
                                      // Destroy Checkout instance      
                                      //checkout.destroy()     
                                      window.GlobalVueInstance.methods.submitForm();
                                    };
                                    const fetchClientSecret = async () => {
                                      const response = await fetch(window.GLOBALCONFIG.API_URL + "/api/create-session-checkout", {
                                        method: "POST",
                                        body: self.payString
                                      });

                                      const { clientSecret } = await response.json();
                                      return clientSecret;
                                    };


                                    window.checkout = await stripe.initEmbeddedCheckout({ fetchClientSecret, onComplete: handleComplete });
                                    // Mount Checkout     

                                    window.checkout.mount('#checkout');




                                  };
                                }


                              });






                              wizard.nosubmit = true;
                              if (stripe_session_id && currentData

                              ) {
                                axios
                                  .get(config.API_URL + "/api/get-session?session_id=" + stripe_session_id).then((response) => {

                                    wizard.root.setPage(wizard.pages.length - 1);

                                    if (response.status == "open") {
                                      $("#checkout").html("failed")

                                    } else {
                                      $("#checkout").html("success")

                                    }
                                  });




                              }
                              // Triggered when they click the submit button.
                              wizard.on('submit', function (submission) {


                                window.submission = submission

                                self.show = true;
                                let formValue = {};
                                formValue.value = JSON.stringify(submission);
                                formValue.collectionValueId = self.form;
                                formValue.formName = self.currentForm.formName;
                                formValue.communityId = self.communityData._id;
                                formValue.definitionName = "formDefintion";
                                if (
                                  document.getElementsByClassName("summaryContainer")
                                    .length > 0
                                ) {


                                  window.summary =
                                    document.getElementsByClassName(
                                      "summaryContainer"
                                    )[0].innerHTML;

                                }

                                formValue.summary = window.summary

                                axios
                                  .post(config.API_URL + "/api/formValue", formValue)
                                  .then((formResponse) => {

                                    formValue.identifier = formResponse.data;
                                    axios
                                      .get(
                                        config.API_URL +
                                        "/api/processForm/" +
                                        formResponse.data
                                      )
                                      .then((response) => {


                                        let nodeRedData = {};
                                        nodeRedData.apiPath = "runFollowUpTasks";
                                        nodeRedData.payload = JSON.stringify(formValue);
                                        axios.post(config.API_URL + "/api/automation", nodeRedData)
                                          .then((formResponse) => {

                                          });

                                        /*         localStorage.setItem('currentData_' + self.form + '_' + window.sessionId, null);
                                                 self.$session.destroy()*/

                                        window.location = config.API_URL.replace("/api/", "") + '/widget/thankyou.html?f=74&c=' + self.community;


                                        self.show = false;
                                      });
                                  });



                              });

                            })
                            .catch((e) => {
                              console.log(e);
                            });



                        });


                    } else if (self.type == "employee") {






                      let query = {};
                      query.query = "usf_GetEmployeeListForCommunityByHash('" + self.community + "')"

                      axios
                        .post(config.API_URL + "/api/dynamicQuery/", query)
                        .then((response) => {



                          let _collectionBaseData = JSON.parse(response.data);
                          let _data = _collectionBaseData
                          let _fullItems = _collectionBaseData
                          if (self.pid == null || self.pid == undefined) {

                            window.componentData = _data;
                            window.fullItems = _fullItems;

                          }
                          else {

                            let tempPid = JSON.parse(self.pid)
                            window.componentData = _data.filter(e => tempPid.includes(e.collectionValueId));

                            window.fullItems = _fullItems;

                          }
                          self.updateKey = moment().format("x")

                        });


                    }
                    else {
                      window.componentData = self.communityData;

                    }
                  });
              }

            });
        }
      })
      .catch((error) => {
        self.hasError = true;
      });
  },

  methods: {
    resolve(path, obj) {
      return path.split("_").reduce(function (prev, curr) {
        return prev ? prev[curr] : null;
      }, obj || self);
    },


    submitForm() {
      let self = this;

      self.payed = true;


    },

    replaceKeysInObj(obj, orgKey, value) {
      if (obj != null) {
        Object.keys(obj).map((key) => {
          if (typeof obj[key] === "object") {
            this.replaceKeysInObj(obj[key], orgKey, value);
          }
          if (obj[key] != null) {
            if (obj[key]["key"] === orgKey) {
              obj[key].html = value;
            }
          }
        });
      }
      return obj;
    },

    formatDate(date, format = "DD.MM.YYYY") {
      return moment(date).format(format);
    },

    formatTime(date, format = "HH:mm") {
      return moment(date, "YYYY-MM-DD HH:mm:ss").format(format);
    },
  },

  watch: {

    language: {
      deep: true,
      handler: function (lang) {
        setLanguage(lang)
      },
    },

  }
};
</script>
<style scoped src="@/assets/css/style.css"></style>

<style scoped>
.loading-background {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.25);
  width: 100%;
  height: 100%;
  z-index: 9999;
  left: 0px;
  right: 0px;
  top: 0%;
  bottom: 0px;
}

.loading-background h3 {

  z-index: 999;
  position: fixed;
  top: 50%;
  left: 0px;
  right: 0px;
  bottom: 0px;
  text-align: center;
  margin-top: 60px;
  display: block;
}

.loader {
  width: 48px;
  height: 48px;
  border: 5px solid #000;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  z-index: 999;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
